<template>
  <header class="top-bar">
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <router-link v-if="backRoute" :to="backRoute" class="breadcrumb-link">
        {{ parentTitle }}
      </router-link>
      <span v-if="backRoute" class="breadcrumb-sep">›</span>
      <span class="breadcrumb-current">{{ currentTitle }}</span>
      <slot name="subtitle" />
    </nav>
    <div class="top-bar-actions">
      <slot />
    </div>
  </header>
</template>

<script>
export default {
  name: 'TopBar',
  props: {
    parentTitle: {
      type: String,
      default: ''
    },
    currentTitle: {
      type: String,
      required: true
    },
    backRoute: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped>
.top-bar {
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-light);
  padding: 0 32px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: var(--z-sticky, 50);
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--text-secondary);
  margin: 0;
  padding: 0;
}

.breadcrumb-link {
  color: var(--text-secondary);
  text-decoration: none;
  transition: color 0.15s;
}

.breadcrumb-link:hover {
  color: var(--feeds-green);
}

.breadcrumb-sep {
  color: var(--text-muted);
}

.breadcrumb-current {
  color: var(--text-primary);
  font-weight: 500;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.breadcrumb ::v-deep .topbar-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 12px;
  padding-left: 12px;
  border-left: 1px solid var(--border-light);
}

.top-bar-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

@media (max-width: 768px) {
  .top-bar {
    padding: 0 16px;
    padding-left: 56px;
    height: 56px;
  }

  .breadcrumb {
    display: none;
  }

  .top-bar-actions {
    gap: 8px;
  }

  .top-bar-actions .button {
    padding: 10px 14px;
    font-size: 13px;
  }
}
</style>
